import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('compPopupStore', Object.keys(getters)),
	...mapState('compPopupStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('compPopupStore', Object.keys(actions)),
	...mapMutations('compPopupStore', Object.keys(mutations))
};
